import DataTable from '@components/layouts/AppDataTable';

type TableEmptyArgs = {
    columnNames?: string[];
};

const TableEmpty = ({ columnNames = [] }: TableEmptyArgs) => {
    return (
        <DataTable
            responsive
            striped
            //@ts-ignore
            columns={columnNames.map((c) => ({
                name: c,
            }))}
            data={[{ foo: 'bar' }]}
        />
    );
};

export default TableEmpty;

